exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ivu-form-item{\n\tmargin-bottom: 20px !important;\n}\n", ""]);

// exports
